import { useDiagramTheme } from './useDiagramTheme';

export function ItemLifecycleDiagram() {
  const p = useDiagramTheme();

  const states = [
    { id: 'intake',     label: 'Intake',      sub: 'Submitted idea',    x: 30,  y: 60,  bg: p.greenBg,   border: p.greenBorder,   text: p.greenText },
    { id: 'triage',     label: 'Triage',      sub: 'Under review',      x: 160, y: 60,  bg: p.amberBg,   border: p.amberBorder,   text: p.amberText },
    { id: 'definition', label: 'Definition',  sub: 'Being defined',     x: 290, y: 60,  bg: p.violetBg,  border: p.violetBorder,  text: p.violetText },
    { id: 'active',     label: 'Active',      sub: 'Ready for cycles',  x: 420, y: 60,  bg: p.emeraldBg, border: p.emeraldBorder, text: p.emeraldText },
    { id: 'in-cycle',   label: 'In Cycle',    sub: 'Being prioritized', x: 420, y: 160, bg: p.indigoBg,  border: p.indigoBorder,  text: p.indigoText },
    { id: 'published',  label: 'Published',   sub: 'Plan of record',    x: 550, y: 110, bg: p.emeraldBg, border: p.emeraldBorder, text: p.emeraldText },
    { id: 'deferred',   label: 'Deferred',    sub: 'On hold',           x: 160, y: 160, bg: p.grayBg,    border: p.grayBorder,    text: p.grayText },
    { id: 'retired',    label: 'Retired',     sub: 'No longer active',  x: 290, y: 160, bg: p.redBg,     border: p.redBorder,     text: p.redText },
  ];

  const arrows = [
    { x1: 100,  y1: 90,  x2: 155, y2: 90  },               // intake → triage
    { x1: 230,  y1: 90,  x2: 285, y2: 90  },               // triage → definition
    { x1: 360,  y1: 90,  x2: 415, y2: 90  },               // definition → active
    { x1: 450,  y1: 130, x2: 450, y2: 155 },               // active → in-cycle
    { x1: 490,  y1: 175, x2: 545, y2: 140 },               // in-cycle → published
    { x1: 490,  y1: 90,  x2: 545, y2: 120 },               // active → published (direct)
    { x1: 230,  y1: 90,  x2: 155, y2: 165, dashed: true }, // triage → deferred
    { x1: 285,  y1: 175, x2: 230, y2: 175 },               // deferred →  retired
  ];

  return (
    <div
      className="w-full border p-4 overflow-x-auto transition-colors"
      style={{ background: p.canvasBg, borderColor: p.canvasBorder }}
    >
      <svg viewBox="0 0 680 240" className="w-full" style={{ minWidth: 520 }}>
        <defs>
          <marker id="il-arrow" markerWidth="7" markerHeight="7" refX="6" refY="3" orient="auto">
            <path d="M0,0 L0,6 L7,3 z" fill={p.arrowColor} />
          </marker>
          <marker id="il-arrow-dashed" markerWidth="7" markerHeight="7" refX="6" refY="3" orient="auto">
            <path d="M0,0 L0,6 L7,3 z" fill={p.arrowDashedColor} />
          </marker>
        </defs>

        {arrows.map((a, i) => (
          <line
            key={i}
            x1={a.x1} y1={a.y1} x2={a.x2} y2={a.y2}
            stroke={a.dashed ? p.arrowDashedColor : p.arrowColor}
            strokeWidth="1.5"
            strokeDasharray={a.dashed ? '4,3' : undefined}
            markerEnd={`url(#il-arrow${a.dashed ? '-dashed' : ''})`}
          />
        ))}

        {states.map((s) => (
          <g key={s.id}>
            <rect x={s.x} y={s.y} width="110" height="52" rx="8"
              fill={s.bg} stroke={s.border} strokeWidth="1.5" />
            <text x={s.x + 55} y={s.y + 22} textAnchor="middle" fontSize="11"
              fontWeight="700" fill={s.text} fontFamily="sans-serif">{s.label}</text>
            <text x={s.x + 55} y={s.y + 38} textAnchor="middle" fontSize="9"
              fill={p.nodeSubText} fontFamily="sans-serif">{s.sub}</text>
          </g>
        ))}

        <text x="340" y="225" textAnchor="middle" fontSize="8.5" fill={p.canvasText}
          fontFamily="sans-serif" fontStyle="italic">
          Top row: active lifecycle path · Bottom row: terminal or holding states
        </text>
      </svg>
      <p className="text-center text-xs mt-1" style={{ color: p.canvasText }}>
        Item status transitions — dashed arrows indicate optional paths
      </p>
    </div>
  );
}
